 
const TriangleWithLines = () => {
  return (
    <div style={styles.container}>
      <svg width="200" height="200" viewBox="0 0 100 100" style={styles.triangle}>
        <polygon points="50,0 100,100 0,100" fill="none" stroke="#000080" strokeWidth="1" transform="rotate(180, 50, 50)" />
        <line x1="10" y1="33" x2="90" y2="33" style={styles.line} transform="rotate(180, 50, 50)" />
        <line x1="20" y1="66" x2="80" y2="66" style={styles.line} transform="rotate(180, 50, 50)" />
      </svg>
      <div style={styles.labels}>
        <div style={styles.label}>&nbsp;Closed</div>
        <div style={styles.label}>&nbsp;Inflight</div>
        <div style={styles.label}>&nbsp;Leads</div>
      </div>
    </div>
  );
};
 
const styles = {
  container: {
    position: 'relative',
    width: '200px',
    height: '200px',
  },
  triangle: {
    position: 'absolute',
    top: '0',
    left: '0',
  },
  line: {
    stroke: '#000080',
    strokeWidth: '0.5',
  },
  labels: {
    position: 'absolute',
    top: '0',
    left: '50%',
    transform: 'translateX(-50%)',
    textAlign: 'center',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '10px 0',
  },
  label: {
    fontSize: '10px',
    color: '#000080',
    margin: '10px 0',
  },
};
 
export default TriangleWithLines;